import React, { useState } from 'react';
import { useFormProps, useMediaQuery } from 'hooks';
import { DialogComponent, AuthError } from 'components/Modals';
import { colors, weight } from 'globalStyle';
import { InputConfirmPassword, InputPassword } from 'components/Form';
import { Hollow } from 'components/Buttons';
import { TextLight } from 'components/Texts';
import TabPanel from 'components/TabPanel';
import { changePasswordUserService } from 'services';
import { Goal } from './Goal';
import { CodeInvestor } from './Code';

export const ChangePassword = ({ isOpen, onClick, user }) => (
  <Tabs onClick={onClick} isOpen={isOpen} user={user} />
);

function Tabs({ onClick, isOpen, user }) {
  const [otp, setOtp] = useState('');
  const [tab, setTab] = useState(0);
  const [error, setError] = useState('');

  const handleError = (err) => {
    setError(err);
  };
  const { formProps, stateFormProps: { isLoading, setLoading } } = useFormProps({
    errorToolTip: true,
    required: true,
  });

  const handleOTP = (code) => {
    const otpConverted = code.toUpperCase();
    setOtp(otpConverted);
  };

  if (error) {
    return (
      <AuthError
        errorMessage={error}
        handleBack={() => {
          setError(false, '');
        }}
        isOpen={isOpen}
        onClick={onClick}
        code={otp}
      />
    );
  }

  return (
    <>
      <TabPanel value={tab} index={0} title>
        <CodeInvestor
          user={user}
          isOpen={isOpen}
          handleOtp={handleOTP}
          onClick={onClick}
          setLoading={setLoading}
          isLoading={isLoading}
          setError={handleError}
          formProps={formProps}
          handleTabs={() => setTab(tab + 1)}
        />
      </TabPanel>
      <TabPanel value={tab} index={1} title>
        <ChangePasswordInvestor
          isOpen={isOpen}
          setOtp={handleOTP}
          onClick={onClick}
          setLoading={setLoading}
          isLoading={isLoading}
          setError={handleError}
          handleTabs={() => setTab(tab + 1)}
          formProps={formProps}
          otp={otp}
        />
      </TabPanel>
      <TabPanel value={tab} index={2}>
        <DialogComponent
          isOpen={isOpen}
          handleClose={onClick}
          handleBack={onClick}
          hasContactUs={false}
        >
          <Goal onClick={onClick} />
        </DialogComponent>
      </TabPanel>
    </>
  );
}

function ChangePasswordInvestor({
  formProps,
  otp,
  handleTabs,
  setLoading,
  setError,
  isLoading,
  isOpen,
  onClick,
}) {
  const submit = (form) => {
    setLoading(true);
    changePasswordUserService({
      oldPassword: form.oldPassword,
      password1: form.password,
      password2: form.password,
      otp,
    })
      .then(() => {
        setLoading(false);
        handleTabs();
      })
      .catch(({ messageFormat }) => {
        setLoading(false);
        setError(messageFormat);
      });
  };
  const isDesktop = useMediaQuery(1023);
  return (
    <DialogComponent isOpen={isOpen} handleClose={onClick} handleBack={onClick}>
      <TextLight
        mb={20}
        size={isDesktop ? 20 : 16}
        color={colors.primary}
        weight={weight.BOLD}
      >
        Cambio de contraseña
      </TextLight>
      <TextLight number={4}>
        Tu contraseña debe tener mínimo ocho (8) caracteres.
      </TextLight>
      <TextLight number={4} mb={20}>
        Al menos una mayuscula, un caracter especial y numeros.
      </TextLight>
      <form onSubmit={formProps.handleSubmit(submit)}>
        <InputPassword
          label="Contraseña actual"
          name="oldPassword"
          style={{
            textAlign: 'start',
            width: `${isDesktop ? '330px' : '100%'}`,
          }}
          toolTip={false}
          {...formProps}
        />
        <InputPassword
          label="Nueva contraseña"
          name="password"
          style={{
            textAlign: 'start',
            width: `${isDesktop ? '330px' : '100%'}`,
          }}
          toolTip={false}
          {...formProps}
        />
        <InputConfirmPassword
          {...formProps}
          style={{
            textAlign: 'start',
            width: `${isDesktop ? '330px' : '100%'}`,
          }}
        />
        <Hollow
          size="14"
          isSubmit
          isLoading={isLoading}
          disabled={formProps.valid}
          style={{
            width: `${isDesktop ? '330px' : '100%'}`,
            margin: '0 0 10px',
            padding: '10px 0',
            height: '45px',
          }}
          onColorType="primary"
        >
          Guardar cambios
        </Hollow>
      </form>
    </DialogComponent>
  );
}
